import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import { motion } from "framer-motion";

const Experience = () => {
  return (
    <Box
      id="experience"
      sx={{
        py: { xs: 6, md: 10 },
        px: 3,

        // 🎨 BLACK BACKGROUND
        backgroundColor: "#fff",
        color: "#000",

        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <Box maxWidth="950px" mx="auto">

        {/* TITLE */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="h4"
            sx={{
              textAlign: "center",
              fontWeight: 700,
              mb: 1,
            }}
          >
            Experience
          </Typography>

          <Typography
            sx={{
              textAlign: "center",
              color: "#111010",
              mb: 6,
            }}
          >
            Accounting • ERP Systems • Financial Control • Full Stack Development
          </Typography>
        </motion.div>

        {/* CARD */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Card
            sx={{
              borderRadius: 3,

              // 🎨 DARK CARD STYLE
              backgroundColor: "#fff",
              color: "#000000",

              border: "1px solid #2a2a2a",
              boxShadow: "0 10px 30px rgba(0,0,0,0.4)",

              p: 2,
              transition: "0.3s",

              "&:hover": {
                transform: "translateY(-6px)",
                boxShadow: "0 15px 40px rgba(0,0,0,0.6)",
              },
            }}
          >
            <CardContent>

              {/* ACCOUNTING EXPERIENCE */}
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Accounting Specialist – Steel Trading Company
              </Typography>

              <Typography sx={{ color: "#01010101", mb: 2 }}>
                Real-World Accounting Experience
              </Typography>

              <Typography sx={{ color: "#000000", lineHeight: 1.8 }}>
                • Handled daily accounting operations and financial transactions  
                <br />
                • Managed journal entries, invoices, and financial records  
                <br />
                • Supported financial reporting and business operations  
              </Typography>

              <Box sx={{ mt: 3 }} />

              {/* CHIEF ACCOUNTING */}
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Chief Accounting & Financial Controlling (Training)
              </Typography>

              <Typography sx={{ color: "#000000 ", mb: 2 }}>
                Advanced Professional Development
              </Typography>

              <Typography sx={{ color: "#000000", lineHeight: 1.8 }}>
                • Financial controlling, budgeting, and cost analysis  
                <br />
                • Financial reporting and decision support  
                <br />
                • ERP and enterprise accounting systems knowledge  
              </Typography>

              <Box sx={{ mt: 3 }} />

              {/* DEVELOPER EXPERIENCE */}
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Remote Full Stack Developer – ERP Systems
              </Typography>

              <Typography sx={{ color: "#000000", mb: 2 }}>
                Software Development Experience
              </Typography>

              <Typography sx={{ color: "#000000", lineHeight: 1.8 }}>
                • Built ERP & accounting systems used by 4+ clients  
                <br />
                • Developed web applications (React, Node.js, Laravel, SQL Server)  
                <br />
                • Designed payroll, VAT, invoices, and reporting modules  
              </Typography>

            </CardContent>
          </Card>
        </motion.div>

      </Box>
    </Box>
  );
};

export default Experience;